/* globals Vue, MediaQuery, _ */
/* exports vm */
/* esnext */

'use strict';

(function(){

    var vm = new Vue({

        el: '#search-app',

        data: {
            config: window.$App,
            texts: window.$App.texts,

            searchInputValue: window.$App.searchQuery || '',
            suggestions: [],
            suggestionsFetched: false,
            searchInputFocussed: false,
            searchSuggestionsVisible: false,
            activeSuggestion: -1,
        },

        mounted () {
            document.addEventListener('keyup', this.handleEscapeKey);
        },

        beforeDestroy () {
            document.removeEventListener('keyup', this.handleEscapeKey);
        },

        computed: {

            __ () {
                return this.texts;
            },

            classNames () {
                return [
                    {
                        'is-search-suggestion-visible': this.searchSuggestionsVisible,
                    }
                ];
            },

            isValidSearchQuery () {
                return (this.sanitizedSearchQuery && this.sanitizedSearchQuery.length >= 3);
            },

            searchTerms () {
                if (this.sanitizedSearchQuery) {
                    return this.sanitizedSearchQuery
                            .replace(/([\s.,;]+)/g,'§sep§')
                            .split('§sep§')
                            .filter(term => term.length >= 2);
                }
                return [];
            },

            sanitizedSearchQuery () {
                return this.searchInputValue ? this.searchInputValue.trim().toLowerCase() : '';
            },

            suggestionMatches () {
                var filter = (this.searchInputValue || '').trim().toLowerCase(),
                    filterRegex = new RegExp('\\b' + filter.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"));

                if (filter && filter.length >= 1) {
                    return this.suggestions.filter(suggestion => suggestion.toLowerCase().match(filterRegex));
                }
                else {
                    return [];
                }
            },
        },

        methods: {

            apiUrl (route) {
                return this.config.urls.api + route + '/';
            },

            focusSearchInput() {
                this.$refs.searchInput.focus();
            },

            blurSearchInput() {
                this.$refs.searchInput.blur();
            },

            handleSearchInputFocus() {
                this.fetchSuggestions();
            },

            handleSearchInputBlur() {
                setTimeout(() => {
                    // this.searchSuggestionsVisible = false;
                }, 250);
            },

            handleEscapeKey(event) {
                if (event.keyCode === 27) { // esc

                }
            },

            handleSubmit(event) {
                // Prevent trailing '?' for empty form submissions
                // by going directly to the action URL

                this.searchSuggestionsVisible = false;

                var serialized = $(this.$refs.searchForm).serialize();
                if (!serialized) {
                    event.preventDefault();
                    window.location = this.$refs.searchForm.action;
                }
            },

            forceSubmit() {
                setTimeout(() => this.$refs.searchForm.submit(), 250);
            },

            handleSuggestionClick(index) {
                this.searchInputValue = this.suggestionMatches[index];
                this.searchSuggestionsVisible = false;
                this.forceSubmit();
            },

            handleSuggestionUp() {
                if (this.activeSuggestion > 0) {
                    this.activeSuggestion--;
                }
            },

            handleSuggestionDown() {
                if (this.activeSuggestion < this.suggestionMatches.length - 1) {
                    this.activeSuggestion++;
                }
            },

            handleSearchInputEnter(event) {
                this.searchSuggestionsVisible = false;
                if (this.activeSuggestion >= 0) {
                    event.preventDefault();
                    this.handleSuggestionClick(this.activeSuggestion);
                }
            },

            isActiveSuggestion(index) {
                return index === this.activeSuggestion;
            },

            fetchSuggestions() {
                if (this.suggestionsFetched) return;

                this.$http.get(this.apiUrl('suggestions/all')).then((response) => {
                    if (response.ok && response.body) {
                        this.suggestions = response.body;
                        this.suggestionsFetched = true;
                    }
                    else {
                        this.handleHttpError(response);
                    }
                }, this.handleHttpError);
            },

            handleHttpError (response) {
                console.error('Error fetching data', response);
            },

        },

        watch: {
            searchInputValue() {
                this.searchSuggestionsVisible = true;
            },
            searchSuggestionsVisible() {
                this.activeSuggestion = -1;
            },
        }
    });

})();
